import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const NotificationOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const NotificationModal = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 2px solid #ff6b6b;
  position: relative;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    color: #333;
  }
`;

const WarningIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  color: #ff6b6b;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
`;

const Message = styled.p`
  color: #333;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 1rem;
`;

const TelegramHandle = styled.div`
  background: #f8f9fa;
  border: 2px solid ${props => props.isChannel ? '#9333ea' : '#0088cc'};
  border-radius: 12px;
  padding: 1rem;
  margin: 1rem 0;
  font-family: 'Courier New', monospace;
  font-size: 1.2rem;
  font-weight: bold;
  color: ${props => props.isChannel ? '#9333ea' : '#0088cc'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.isChannel ? '#f3e8ff' : '#e6f3ff'};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ActionButton = styled.button`
  background: #0088cc;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin: 0 0.5rem;

  &:hover {
    background: #006ba6;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const SecondaryButton = styled(ActionButton)`
  background: #6c757d;
  
  &:hover {
    background: #5a6268;
  }
`;

const TelegramNotification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show notification every time
    setIsVisible(true);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleOpenTelegram = (account) => {
    let url;
    if (account === 'channel') {
      url = 'https://t.me/+ykwX_zYA-dczNmY0';
    } else {
      url = `https://t.me/${account}`;
    }
    window.open(url, '_blank');
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <NotificationOverlay onClick={handleClose}>
      <NotificationModal onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={handleClose}>&times;</CloseButton>
        
        <WarningIcon>⚠️</WarningIcon>
        
        <Title>Important Notice</Title>
        
        <Message>
          My previous Telegram account has been banned. Please click on my new accounts and channel below:
        </Message>
        
        <TelegramHandle onClick={() => handleOpenTelegram('deserved0')}>
          📱 @deserved0
        </TelegramHandle>
        
        <TelegramHandle onClick={() => handleOpenTelegram('tomnookbank')}>
          📱 @tomnookbank
        </TelegramHandle>
        
        <TelegramHandle isChannel onClick={() => handleOpenTelegram('channel')}>
          📢 deserved public (Channel)
        </TelegramHandle>
        
        <Message>
          Click the accounts for direct support or the channel for updates.
        </Message>
        
        <div>
          <SecondaryButton onClick={handleClose} style={{ width: '100%' }}>
            Got it
          </SecondaryButton>
        </div>
      </NotificationModal>
    </NotificationOverlay>
  );
};

export default TelegramNotification; 